import React from 'react';
import { setHeaderHeight } from '../../globals/HeaderUtils';
import { promoProjectShortTitle } from '../../globals/ProjectVars';

export class ATHButton extends React.Component {
    constructor(props) {
        super(props);

        this.showPrompt = this.showPrompt.bind(this);
    }

    componentDidMount() {
        setHeaderHeight();
    }

    showPrompt(e) {
        e.preventDefault();
        this.props.showPrompt();
    }

    render() {

        return (
            <a className="btn athBtn" role="button" onClick={this.showPrompt}>Add {promoProjectShortTitle} to your homescreen</a>
        );
    }
}